module.exports = __webpack_public_path__ + "static/img/login-icon.b70ebb0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login-icon.jpg
// module id = Ypf6
// module chunks = 1